'use client'

import Link from 'next/link'

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-srperrito-dark text-srperrito-cream p-4">
      <h2 className="text-4xl font-bold mb-4">Página no encontrada</h2>
      <p className="text-xl mb-8">No pudimos encontrar la página que estás buscando</p>
      <Link
        href="/"
        className="px-6 py-3 bg-srperrito-cream text-srperrito-dark font-bold rounded-lg hover:bg-srperrito-cream/90 transition-colors"
      >
        Volver al inicio
      </Link>
    </div>
  )
}
